import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hidePhone',
})
export class HidePhonePipe implements PipeTransform {
  transform(number: string | number | undefined): string | number | undefined {
    if (!number) return number;
    if (typeof number === 'number') number = number.toString();
    number = number.replace(/\d(?=\d{3})/g, '*');
    number = number.match(/.{1,3}/g)?.join(' ') ?? number;
    return number;
  }
}
